import { http } from '@/core/api/';
const apiUrl = 'api/taprequests';

export const getSpecialistBySpecialtyType = async (
  academicYearId,
  companyId,
  specialtyTypeId
) =>
  await http.get(
    `${apiUrl}/specialistbyspecialtytype?academicYearId=${academicYearId}&companyId=${companyId}&specialtyType=${specialtyTypeId}`
  );

export const getEducativeServicePlacements = async (
  teacehrId,
  academicYearId,
  companyId
) =>
  await http.get(
    `${apiUrl}/educativeserviceplacements?teacherId=${teacehrId}&academicYearId=${academicYearId}&companyId=${companyId}`
  );

export const assignTeacher = async (assignment) =>
  await http.post(`${apiUrl}/assignteacher`, assignment);

export const saveAmendment = async (model) =>
  await http.post(`${apiUrl}/saveamendment`, model);
